export default "__VITE_ASSET__4KKs60GJ__"